import { Component, computed, ViewEncapsulation } from '@angular/core';
import { ListRendererWidgetBase } from '@capturum/builders/list-renderer';

@Component({
  selector: 'app-colored-column-by-status',
  template: `<p [style]="{ color: statusBasedColor() }">{{ item?.duration_when_is_allocated ?? '' }}</p>`,
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['colored-column-by-status.component.scss'],
})
export class ColoredColumnByStatusComponent extends ListRendererWidgetBase {
  public statusBasedColor = computed(() => {
    return this.item?.status_duration_color;
  });
}
